import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import _ from 'lodash'

import * as Constants from '../../../../../../helpers/constants';
import LineChart from '../../../../../widgets/linechart';
import FiltersComponent from '../../../../../widgets/filters';
import * as FiltersConstants from '../../../../../widgets/filters/constants'
import { ApiHelper } from '../../../../../../helpers/apihelper';

import '../analytics.css'
import 'react-circular-progressbar/dist/styles.css';

const FormGuard = ({ client }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const co_user_id = queryParams.get('user_id') || queryParams.get('org_id');

  const initialstate = {
    filters: {
      date_range: {
        filter_label: 'Date',
        label: 'Last 7 days (Including Today)',
        value: 'ps_last_7_days_including_today'
      }
    },
  }
  const [formGuardData, setFormGuardData] = useState({
    total: 0,
    email: 0,
    phone: 0,
    name: 0
  });
  const [lineChartData, setLineChartData] = useState({
    labels: [],
    breakdown: [],
    values: [],
  });

  const [state, setState] = useState(initialstate)
  useEffect(() => {
    const filter = {
      org_id: null,
      date_range: state.filters.date_range?.value ? state.filters.date_range?.value : null,
      member_id: null,
      user_id: co_user_id,
    };
    const requestQueryParams = {
      user_id: co_user_id,
      filters: JSON.stringify(filter),
    };

    let queryParams = _.pick(requestQueryParams, ApiHelper(client, 'FORM_GUARD_REPORTS').API_QUERY)

    ApiHelper(client, 'FORM_GUARD_REPORTS').API(client, queryParams)
      .then((response) => {
        if (response && response.status === Constants.CO_API.SUCCESS) {
          const stats = response.data.user_stats[0].stats;

          const email = stats.reduce((total, stat) => total + stat.email.credits_used, 0);
          const phone = stats.reduce((total, stat) => total + stat.phone.credits_used, 0);
          const name = stats.reduce((total, stat) => total + stat.name.credits_used, 0);

          setFormGuardData({
            email,
            phone,
            name,
            total: email + phone + name
          });

          const statsArray = response.data.user_stats[0]?.stats || []

          setLineChartData({
            labels: statsArray.map((stat) => stat.date),
            values: [
              {
                label: 'Name',
                data: statsArray.map((stat) => stat.name.credits_used),
              },
              {
                label: 'Email',
                data: statsArray.map((stat) => stat.email.credits_used),
              },
              {
                label: 'Phone',
                data: statsArray.map((stat) => stat.phone.credits_used),
              },
            ],
          })
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [co_user_id, state.filters, client]);


  const onSetFilter = (filters) => {
    setState(prevState => ({ ...prevState, filters: { ...filters } }))
  }


  return (
    <>
      <FiltersComponent
        filterState={state.filters}
        onSetFilters={onSetFilter}
        filters={FiltersConstants.ANALYTICS[client].filters}
        filtersToInclude={FiltersConstants.FILTERS_TO_INCLUDE[client].ANALYTICS}
        className='analytics-filter'
        resetFilters={FiltersConstants.ANALYTICS[client].onResetFilters}
      />
      <div className="overview-container border rounded p-3">
        <div className="row">
          {/* Left Box */}
          <div className="col text-center">
            <div className='total-verified fw-bold fs-5'>
              <p>Total Credits</p>
              <p className='text-orange'>{formGuardData.total}</p>
            </div>
            <div className='total-verified fw-bold fs-5'>
              <p>Email Validation</p>
              <p className='text-orange'>{formGuardData.email}</p>
            </div>
            <div className='total-verified fw-bold fs-5'>
              <p>Phone Validation</p>
              <p className='text-orange'>{formGuardData.phone}</p>
            </div>
            <div className='total-verified fw-bold fs-5'>
              <p>Name Validation</p>
              <p className='text-orange'>{formGuardData.name}</p>
            </div>
          </div>
          {/* Separator */}
          <div className="col-1 border-start"></div>
          {/* Right Box */}
          <div className="col-8 text-center analytics-chart">
            <LineChart
              graphData={lineChartData}
              width={300}
              height={250}
              position="bottom"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default FormGuard;
